<template>
    <div class="inline-block">
        <div v-if="formOpen === false">
            <button
                type="button"
                @click="open()"
                class="text-indigo-700 bg-indigo-100 hover:bg-indigo-200 inline-flex items-center px-1.5 py-1.5 border border-transparent text-xs font-medium rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
                <svg viewBox="0 0 20 20" fill="currentColor" class="pencil w-4 h-4">
                    <path
                        d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"
                    ></path>
                </svg>
            </button>
        </div>
        <template v-else>
            <Modal :show="formOpen" @close="formOpen = false">
                <div class="">
                    <SingleTextModalForm
                        :button-text="$t('messages.edit')"
                        :endpoint="field.edit_endpoint"
                        :text="field.name"
                        is-inline
                        is-edit
                        use-square-button
                    >
                        <template #inline-text>
                            <div class="font-semibold">
                                {{ field.name }}
                            </div>
                        </template>
                    </SingleTextModalForm>
                </div>

                <div class="mt-5">
                    <div v-for="option in field.options" :key="option.id" class="mt-3">
                        <div class="flex space-x-2">
                            <SingleTextModalForm
                                :button-text="$t('messages.edit')"
                                :endpoint="option.edit_endpoint"
                                :text="option.text"
                                column="text"
                                is-inline
                                is-edit
                                use-square-button
                            >
                                <template #inline-text>
                                    <div class="">
                                        {{ option.text }}
                                    </div>
                                </template>
                            </SingleTextModalForm>
                            <InertiaInlineSquareDeleteButton :href="option.delete_endpoint.url" />
                        </div>
                    </div>
                </div>
                <div class="mt-5">
                    <SingleTextModalForm
                        :button-text="$tc('messages.options', 1)"
                        :endpoint="field.option_create_endpoint"
                        column="text"
                        with-create-icon
                        is-inline
                    />
                </div>
            </Modal>
        </template>
    </div>
</template>

<script>
import Modal from '@/components/Modal.vue';
import SingleTextModalForm from '@/components/pageSpecific/SingleTextModalForm.vue';
import InertiaInlineSquareDeleteButton from '@/components/InertiaInlineSquareDeleteButton.vue';

export default {
    name: 'StudentFileFieldEditModalForm',
    components: {
        InertiaInlineSquareDeleteButton,
        Modal,
        SingleTextModalForm,
    },
    props: {
        field: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            formOpen: false,
        };
    },
    methods: {
        cancel() {
            this.formOpen = false;
        },
        open() {
            this.formOpen = true;
        },
        onEscape(e) {
            if (e.key === 'Esc' || e.key === 'Escape') {
                this.open = false;
            }
        },
    },
    beforeUnmount() {
        document.removeEventListener('keydown', this.onEscape);
    },
    mounted() {
        document.addEventListener('keydown', this.onEscape);
    },
};
</script>
